var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28848 4.42836L4.13435 2.5825L4.50718 2.20966L4.86335 2.56583L6.70922 4.41169L7.50172 5.20419C7.75436 5.45683 8.16397 5.45683 8.41662 5.20419C8.66926 4.95155 8.66926 4.54194 8.41662 4.28929L7.62411 3.49679L5.77825 1.65093L4.98575 0.858427C4.80628 0.678963 4.54761 0.626981 4.32226 0.702481C4.20854 0.728924 4.10059 0.786463 4.01195 0.875098L3.21945 1.6676L1.37358 3.51346L0.581083 4.30597C0.328441 4.55861 0.328441 4.96822 0.581083 5.22086C0.833725 5.47351 1.24334 5.47351 1.49598 5.22086L2.28848 4.42836ZM2.28848 9.96845L4.13435 11.8143L4.50718 12.1872L4.86335 11.831L6.70922 9.98512L7.50172 9.19262C7.75436 8.93998 8.16397 8.93998 8.41661 9.19262C8.66926 9.44527 8.66926 9.85488 8.41661 10.1075L7.62411 10.9L5.77825 12.7459L4.98575 13.5384C4.80628 13.7179 4.54761 13.7698 4.32226 13.6943C4.20854 13.6679 4.10059 13.6104 4.01195 13.5217L3.21945 12.7292L1.37358 10.8834L0.581083 10.0909C0.328441 9.83821 0.328441 9.42859 0.581083 9.17595C0.833725 8.92331 1.24334 8.92331 1.49598 9.17595L2.28848 9.96845Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.4eac371515e864fce9d4f2c378799d55.svg";
export { ForwardRef as ReactComponent };